<template>
  <v-app>
    <slot />
  </v-app>
</template>

<script>
export default {
  name: 'AppContainer'
}
</script>

<style lang="scss">
/* @import '../sass/app.scss'; */
</style>
